export default __webpack_public_path__ + "static/media/clusterIcon.ac9288cc.png";